import React, { Component } from "react";
import { Route, Switch, withRouter } from "react-router-dom";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import AcademicYears from "./components/AcademicAdministration/AcademicYears/AcademicYears";
import ReceiptTemplate from "./components/Accounting/ReceiptTemplate";
import Template3 from "./components/CardsAndCertificates/CardTemplates/Template3";
import DashboardTemplate from "./components/Dashboard/DashboardTemplate";
import Dictionary from "./components/Dictionary/Dictionary";
import NotFound from "./components/Error Page/NotFound";
import FamilyPage from "./components/FamilyPage/FamilyPage";
import GroupPage from "./components/GroupPage/GroupPage";
import ChangePassword from "./components/Login/ChangePassword";
import LoginCentralNew from "./components/Login/LoginCentralNew";
import OTPpage from "./components/Login/OTPpage";
import PrivateLogin from "./components/Login/privateLogin";
import ARRManager from "./components/Permissions/ARRManager";
import DefaultSettings from "./components/Permissions/DefaultSettings";
import ModerationManager from "./components/Permissions/ModerationManager";
import PermissionConfiguration from "./components/Permissions/PermissionConfiguration";
import UserManager from "./components/Permissions/UserManager";
import PrivateRoute from "./components/PrivateRoute/PrivateRoute";
import ProfilePage from "./components/Profile/ProfilePage";
import ArticleTemplate from "./components/Profile/Templates/ArticleTemplate";
import DiscussionTemplate from "./components/Profile/Templates/DiscussionTemplate";
import MediaTemplate from "./components/Profile/Templates/MediaTemplate";
import RegisterPage from "./components/Register/RegisterPage";
import SchoolLMS from "./components/SchoolLMS/SchoolLMS";
import SchoolManager from "./components/SchoolManager/SchoolManager";
import SearchPage from "./components/SearchModule/SearchPage";
import SystemSetup from "./components/SystemSetup/SystemSetup";
import TechnicalSchool from "./components/TechnicalSchools/TechnicalSchool";
import CentralProfile from "./pages/Profile/CentralProfile";
import { axiosPost } from "./utils/AxiosApi";
import { checkUserRole, URL } from "./utils/Constants";
import history from "./utils/History";

class App extends Component {
  constructor() {
    super();
    const token = localStorage.getItem("token");

    const twoFAEnabled = localStorage.getItem("is2FAEnabled");

    if (twoFAEnabled === "true") {
      const otpVerified = localStorage.getItem("otpVerified");

      if (token) {
        this.state = {
          isLoggedIn: otpVerified && otpVerified === "true",
          systemSetup:
            localStorage.getItem("schoolSetup") === "true",
          academicYears:
            localStorage.getItem("academicYears") === "true",
          toggleOtp:
            localStorage.getItem("is2FAEnabled") === "true",
        };
      } else {
        this.state = {
          isLoggedIn: false,
          systemSetup:
            localStorage.getItem("schoolSetup") === "true",
          academicYears:
            localStorage.getItem("academicYears") === "true",
        };
      }
      return;
    }
    if (token) {
      this.state = {
        isLoggedIn: true,
        systemSetup:
          localStorage.getItem("schoolSetup") === "true",
        academicYears:
          localStorage.getItem("academicYears") === "true",
        toggleOtp:
          localStorage.getItem("is2FAEnabled") === "true",
      };
    } else {
      this.state = {
        isLoggedIn: false,
        systemSetup:
          localStorage.getItem("schoolSetup") === "true",
        academicYears:
          localStorage.getItem("academicYears") === "true",
      };
    }
  }

  componentDidMount() {
    // this.state.isLoggedIn && this.checkSystemAcademicSetup();
    // this.getWebsiteConfig();
    this.setupBeforeUnloadListener();
  }

  // Setup the `beforeunload` event listener JS
  setupBeforeUnloadListener = () => {
    window.addEventListener("beforeunload", (ev) => {
      // ev.preventDefault();
      return this.doSomethingBeforeUnload();
    });
  };

  doSomethingBeforeUnload = () => {
    // biome-ignore lint/suspicious/noPrototypeBuiltins: <explanation>
    if (localStorage.hasOwnProperty("webUserType")) {
      localStorage.removeItem("webUserType");
    }
  };

  getWebsiteConfig = () => {
    axiosPost(URL.getWebsiteConfig, {}, (response) => {
      if (response.status === 200) {
        if (response.data.data.length > 0) {
          const favIcon = document.getElementById("favicon");
          let touchIcon = document.getElementById("touchIcon");
          favIcon.href = URL.imageSelectURL + response.data.data[0].faviconPath;
          touchIcon = URL.imageSelectURL + response.data.data[0].faviconPath;
        } else {
        }
      }
    });
  };

  checkSystemAcademicSetup = async () => {
    axiosPost(URL.checkSystemAcademicSetup, {}, (response) => {
      if (response.status === 200) {
        const systemSetup = response.data.data.systemSetup
        const academicYears = response.data.data.academicYearSetup;
        localStorage.setItem("schoolSetup", true);
        localStorage.setItem("academicYears", true);
        this.setState({ systemSetup, academicYears });
        // if (systemSetup && academicYear) {
        // } else if (systemSetup && !academicYear) {
        //   history.push(`${process.env.PUBLIC_URL}/academicYears`);
        // } else {
        //   history.push(`${process.env.PUBLIC_URL}/systemSetup`);
        // }
      }
    });
  };

  render() {
    return (
      <Switch>
        <PrivateRoute
          authed={this.state.isLoggedIn}
          path="/profile/:username"
          component={ProfilePage}
        />
        <PrivateRoute
          authed={this.state.isLoggedIn}
          path="/systemSetup"
          component={SystemSetup}
        />
        {/* <PrivateRoute
          authed={this.state.isLoggedIn}
          path={`/academicYears`}
          component={AcademicYears}
        /> */}
        <PrivateRoute
          authed={localStorage.getItem("token")}
          path="/otp"
          component={this.state.isLoggedIn ? ProfilePage : OTPpage}
        />
        <Route
          path="/profile"
          component={
            this.state.isLoggedIn &&
              this.state.systemSetup &&
              this.state.academicYears
              ? ProfilePage
              : this.state.isLoggedIn && !this.state.systemSetup
                ? SystemSetup
                : this.state.isLoggedIn &&
                  this.state.systemSetup &&
                  !this.state.academicYears
                  ? AcademicYears
                  : PrivateLogin
          }
        />
        <Route
          path="/login-central"
          render={() => {
            if (
              this.state.isLoggedIn &&
              (localStorage.getItem("mainUserId") === "1" || checkUserRole())
            ) {
              history.push("/dashboard/main");
            } else if (this.state.isLoggedIn) {
              history.push("/profile");
            } else {
              return <LoginCentralNew />;
              // return <PrivateLogin />;
            }
          }}
        />
        <Route
          path="/school-login"
          render={() => {
            if (
              this.state.isLoggedIn &&
              (localStorage.getItem("mainUserId") === "1" || checkUserRole())
            ) {
              history.push("/dashboard/main");
            } else if (this.state.isLoggedIn) {
              history.push("/profile");
            } else {
              return <PrivateLogin />;
            }
          }}
        />
        <Route
          path="/login"
          render={() => {
            if (
              this.state.isLoggedIn &&
              (localStorage.getItem("mainUserId") === "1" || checkUserRole())
            ) {
              history.push("/dashboard/main");
            } else if (this.state.isLoggedIn) {
              history.push("/profile");
            } else {
              return <PrivateLogin />;
            }
          }}
        />
        <PrivateRoute
          path="/dashboard"
          authed={this.state.isLoggedIn && (localStorage.getItem("mainUserId") === "1" || checkUserRole())}
          component={DashboardTemplate}
        />
        <Route
          path="/"
          exact
          render={() => {
            if (
              this.state.isLoggedIn &&
              this.state.systemSetup &&
              this.state.academicYears
            ) {
              if ((localStorage.getItem("mainUserId") === "1" || checkUserRole())) {
                history.push("/dashboard/main");
              } else {
                history.push("/profile");
              }
            } else if (this.state.isLoggedIn && !this.state.systemSetup) {
              return <SystemSetup />;
            } else if (this.state.isLoggedIn &&
              this.state.systemSetup &&
              !this.state.academicYears) {
              return <AcademicYears />;
            } else {

              return <PrivateLogin />;
            }
          }}
        />
        <PrivateRoute
          path="/groupPage/:groupName"
          component={GroupPage}
          authed={this.state.isLoggedIn}
        />
        <PrivateRoute
          path="/search-imagine"
          component={SearchPage}
          authed={this.state.isLoggedIn}
        />
        <PrivateRoute
          path="/permissionConfiguration"
          component={PermissionConfiguration}
          authed={this.state.isLoggedIn}
        />

        <PrivateRoute
          path="/school-manager"
          component={SchoolManager}
          authed={this.state.isLoggedIn}
        />

        <PrivateRoute
          path="/usermanager"
          component={UserManager}
          authed={this.state.isLoggedIn}
        />
        <PrivateRoute
          path="/arrmanager"
          component={ARRManager}
          authed={this.state.isLoggedIn}
        />
        <PrivateRoute
          path="/moderation_manager"
          component={ModerationManager}
          authed={this.state.isLoggedIn}
        />
        <PrivateRoute
          path="/default_settings"
          component={DefaultSettings}
          authed={this.state.isLoggedIn}
        />
        <PrivateRoute
          path="/moderation_manager"
          component={ModerationManager}
          authed={this.state.isLoggedIn}
        />
        <PrivateRoute
          path="/groupPage/:groupName"
          component={GroupPage}
          authed={this.state.isLoggedIn}
        />
        <PrivateRoute
          path="/dictionary"
          component={Dictionary}
          authed={this.state.isLoggedIn}
        />
        <PrivateRoute
          path="/myprofile"
          component={CentralProfile}
          authed={this.state.isLoggedIn}
        />
        <PrivateRoute
          path="/post/article/:referenceId"
          component={ArticleTemplate}
          authed={this.state.isLoggedIn}
        />
        <PrivateRoute
          path="/post/discussion/:referenceId"
          component={DiscussionTemplate}
          authed={this.state.isLoggedIn}
        />
        <PrivateRoute
          path="/post/media/:referenceId"
          component={MediaTemplate}
          authed={this.state.isLoggedIn}
        />
        <Route path="/technical-schools" component={TechnicalSchool} />
        <PrivateRoute
          path="/familyPage/:familyId"
          component={FamilyPage}
          authed={this.state.isLoggedIn}
        />
        {/* <Route
          path="/"
          exact
          component={
            this.state.isLoggedIn &&
            this.state.systemSetup &&
            this.state.academicYears
              ? ProfilePage
              : this.state.isLoggedIn && !this.state.systemSetup
              ? SystemSetup
              : this.state.isLoggedIn &&
                this.state.systemSetup &&
                !this.state.academicYears
              ? AcademicYears
              : PrivateLogin
          }
        />
        <Route
          path="/home"
          exact
          component={
            this.state.isLoggedIn &&
            this.state.systemSetup &&
            this.state.academicYears
              ? ProfilePage
              : this.state.isLoggedIn && !this.state.systemSetup
              ? SystemSetup
              : this.state.isLoggedIn &&
                this.state.systemSetup &&
                !this.state.academicYears
              ? AcademicYears
              : PrivateLogin
          }
        />
        {/* <Route
          path="/reportingConfig"
          component={ReportingConfiguration}
        ></Route> */}
        {/* <Route path="/exam" component={SystemExamConfiguration}></Route> */}
        {/* <Route path="/takeexam" component={ExamForm}></Route> */}
        {/* <Route path="/assessexam" component={SystemExamAssessment}></Route> */}
        {/* <Route path="/attendance" component={Attendance}></Route> */}
        <Route path="/resetPassword/:userId" component={ChangePassword} />
        <Route path="/slms" component={SchoolLMS} />
        <Route path="/template1" component={ReceiptTemplate} />
        <Route path="/signup" component={RegisterPage} />
        <Route path="/cardTemplate" component={Template3} />
        {/* website routes student and teacher page  */}
        {/* <Route
          path="/newGradePage"
          render={() => <NewGradePage homePage={true} />}
        ></Route>
        <Route
          path="/newTeacherPage"
          render={() => <NewTeacherPage homePage={true} />}
        ></Route> */}
        {/* profile routes student and teacher */}
        {/* <PrivateRoute
          path="/student"
          component={NewGradePage}
          authed={true}
        />
        <PrivateRoute
          path="/teacher"
          component={NewTeacherPage}
          authed={true}
        />
        <PrivateRoute
          path="/otheractivities"
          component={OtherActivities}
          authed={true}
        />
        <PrivateRoute
          path="/all-notices"
          component={AllNotices}
          authed={true}
        />
        <PrivateRoute
          path="/discussion"
          component={CentralDiscussion}
          authed={this.state.isLoggedIn}
        />
        <PrivateRoute
          path="/notices"
          component={ProfileNotices}
          authed={this.state.isLoggedIn}
        />
        <PrivateRoute
          path="/customCalculator"
          component={CustomCalculator}
          authed={this.state.isLoggedIn}
        />
        <PrivateRoute
          path="/relative-links"
          component={RelativeLinksPage}
          authed={this.state.isLoggedIn}
        /> */}
        <Route path="*" render={() => <NotFound />} />
      </Switch>
    );
  }
}

export default withRouter(App);
